import {Source, Layer} from '../MaptilerWrapper'
import PropTypes from 'prop-types'
import {useTheme} from '@mui/material/styles'

const HeatMapLayer = ({data = {}, isOutreachSimulationSelected = false, isPersonaSelected = false}) => {
  const theme = useTheme()
  // Common heatmap properties
  const commonHeatmapPaint = {
    'heatmap-radius': ['interpolate', ['linear'], ['zoom'], 5, 4, 11, 10, 12, 15, 13, 20, 14, 30, 15, 50],
    'heatmap-opacity': 0.8
  }

  // Render grouped heatmap layers
  const renderGroupedHeatMap = () => {
    if (!Array.isArray(data)) return null

    return data.map((group, i) => (
      <Source id={`heat-source-${group.key}`} type='geojson' data={group.data} key={group.key}>
        <Layer
          id={`heat-layer-${group.key}`}
          beforeId={i === 0 ? undefined : `heat-layer-${data[i - 1].key}`}
          type='heatmap'
          paint={{
            ...commonHeatmapPaint,
            'heatmap-color': group.style
          }}
          maxzoom={15}
        />
      </Source>
    ))
  }

  // Render default heatmap layer
  const renderDefaultHeatMap = () => (
    <Source id='heat-source' type='geojson' data={data}>
      <Layer
        id='heat-layer'
        type='heatmap'
        paint={{
          ...commonHeatmapPaint,
          'heatmap-color': [
            'interpolate',
            ['linear'],
            ['heatmap-density'],
            0,
            theme.palette.heatmapColor.default,
            0.3,
            theme.palette.hpAccentLightPink,
            0.6,
            theme.palette.hpAccentPink,
            1,
            theme.palette.hpAccentDarkPink
          ]
        }}
        maxzoom={15}
      />
    </Source>
  )

  // Determine which heatmap to render
  return isOutreachSimulationSelected || isPersonaSelected ? renderGroupedHeatMap() : renderDefaultHeatMap()
}

HeatMapLayer.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  isOutreachSimulationSelected: PropTypes.bool,
  isPersonaSelected: PropTypes.bool
}

export default HeatMapLayer

/**
 * List of functions and their purpose:
 *
 * - renderGroupedHeatMap: Renders heatmap layers for grouped data with multiple colors.
 * - renderDefaultHeatMap: Renders a single heatmap layer with a default color gradient.
 * - HeatMapLayer: Decides which heatmap to render based on outreach simulation or persona selection.
 */
